import * as THREE from 'three';
import type { Effect, Particle } from '../game/types';

export class EffectsSystem {
  private readonly particles: Particle[] = [];
  private readonly effects: Effect[] = [];

  constructor(private readonly scene: THREE.Scene) {}

  burst(position: THREE.Vector3, color: number, amount = 8): void {
    for (let i = 0; i < amount; i++) {
      const mesh = new THREE.Mesh(new THREE.BoxGeometry(0.06, 0.06, 0.06), new THREE.MeshBasicMaterial({ color, transparent: true }));
      mesh.position.copy(position);
      this.scene.add(mesh);
      this.particles.push({ mesh, velocity: new THREE.Vector3((Math.random() - 0.5) * 2.5, Math.random() * 2.2, (Math.random() - 0.5) * 2.5), life: 0.35 + Math.random() * 0.35 });
    }
    const ring = new THREE.Mesh(new THREE.RingGeometry(0.17, 0.23, 18), new THREE.MeshBasicMaterial({ color, transparent: true, opacity: 0.75, side: THREE.DoubleSide }));
    ring.rotation.x = -Math.PI / 2;
    ring.position.copy(position).setY(0.08);
    this.scene.add(ring);
    this.effects.push({ mesh: ring, life: 0.38, maxLife: 0.38 });
  }

  update(dt: number): void {
    for (let i = this.particles.length - 1; i >= 0; i--) {
      const particle = this.particles[i];
      particle.life -= dt;
      particle.mesh.position.addScaledVector(particle.velocity, dt);
      particle.velocity.y -= dt * 1.9;
      particle.mesh.scale.multiplyScalar(1 - dt * 1.6);
      if (particle.life <= 0) {
        this.scene.remove(particle.mesh);
        this.particles.splice(i, 1);
      }
    }
    for (let i = this.effects.length - 1; i >= 0; i--) {
      const effect = this.effects[i];
      effect.life -= dt;
      effect.mesh.scale.setScalar(1 + (1 - effect.life / effect.maxLife) * 2.3);
      effect.mesh.material.opacity = Math.max(0, effect.life / effect.maxLife) * 0.72;
      if (effect.life <= 0) {
        this.scene.remove(effect.mesh);
        this.effects.splice(i, 1);
      }
    }
  }
}
